import { render, staticRenderFns } from "./Paycheck.vue?vue&type=template&id=bec02650&scoped=true"
import script from "./Paycheck.vue?vue&type=script&lang=js"
export * from "./Paycheck.vue?vue&type=script&lang=js"
import style0 from "./Paycheck.vue?vue&type=style&index=0&id=bec02650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec02650",
  null
  
)

export default component.exports